<main-form-modal>
    <ng-template #customHtmlElements>
        <div>
            <ivr-donation-user-task-details></ivr-donation-user-task-details>
        </div>
    </ng-template>
</main-form-modal>